(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-roster-gallery"] && !window.DesignMode) return;
  try {
    
    console.clear();
    gsap.registerPlugin(ScrollTrigger);
    
    const additionalY = { val: 0 };
    let additionalYAnim;
    const cols = gsap.utils.toArray(".col");
    
    // DETECT IF MOBILE DEVICE
    const isMobile = window.innerWidth <= 50;
    
    cols.forEach((col, i) => {
      let images = Array.from(col.children);
      let colHeight = col.scrollHeight;
    
      // DUPLICATE IMAGES UNTIL COLUMN HEIGHT FILLS AT LEAST 200% OF VIEWPORT
      while (col.scrollHeight < window.innerHeight * (isMobile ? 3 : 2)) {
        images.forEach((img) => {
          let clone = img.cloneNode(true);
          col.appendChild(clone);
        });
        images = Array.from(col.children);
      }
    
      // SCROLL ANIMATION (SLOWER FOR MOBILE)
      let direction = i % 2 === 0 ? "-=" : "+=";
      gsap.to(col, {
        y: direction + colHeight / (isMobile ? 1.5 : 2),
        duration: isMobile ? 30 : 20, // Slower scroll for mobile
        repeat: -1,
        ease: "none",
        modifiers: {
          y: gsap.utils.unitize((y) => parseFloat(y) % colHeight),
        },
      });
    });
    
    // SCROLL INTERACTION TO ADJUST SPEED
    const imagesScrollerTrigger = ScrollTrigger.create({
      trigger: "section",
      start: "top 50%",
      end: "bottom 50%",
      onUpdate: function (self) {
        const velocity = self.getVelocity();
        if (velocity !== 0) {
          if (additionalYAnim) additionalYAnim.kill();
          additionalY.val = -velocity / (isMobile ? 5000 : 3000);
          additionalYAnim = gsap.to(additionalY, { val: 0 });
        }
      },
    });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-vertical-slider"] && !window.DesignMode) return;
  try {
    
  $('.myslider').slick({

    vertical: true,
    autoplay: true,
      autoplaySpeed: 0,
      speed: 5000,
      arrows: false,
      swipe: false,
      slidesToShow: 1,
      cssEase: 'linear',
      pauseOnFocus: false,
      pauseOnHover: false,  
      
    });
	

  } catch(e) { console.error(e); }
})();
})();
